/** @format */

import useAsync from './use_request';
import SuperAgent from 'superagent';

export function useShippingEstimator({
    order,
    address1,
    state,
    zip,
    city,
    country,
    region,
    isResidential
}) {
    const {data, isPending, error} = useAsync(
        order.id && zip
            ? [
                  order.id,
                  order.total_qty,
                  order.width,
                  order.length,
                  order.depth,
                  zip,
                  city,
                  isResidential
              ]
            : null,
        async ({abortable}) => {
            try {
                const res = await abortable(
                    SuperAgent.post(`/account/shipments/get-rates-by-order/${order.id}`)
                        .set('Accept', 'application/json')
                        .send({
                            address1,
                            city,
                            state,
                            zip,
                            country,
                            region,
                            is_residential: isResidential
                        })
                );

                return res.body;
            } catch (error) {
                const msg = error.response?.body?.message;
                // Some zips require a city to be specified. This error message appears
                // when that's the case, so provide a more helpful error to the user.
                if (msg?.includes('Invalid Destination.')) {
                    throw new Error('Please enter a city.');
                } else if (msg) {
                    throw new Error(msg);
                }
                throw error;
            }
        },
        {debounce: 500, initial: []}
    );

    return {
        data,
        isPending,
        error
    };
}
